<template>
  <div class="order-rate-shop-tab" :class="tab.key">
    <RateShopView
      :id="`rate-shop-for-shipment-spec-${shipmentSpecId}`"
      v-model:service-type-filters="serviceTypeFilters"
      :rate-shop="rateShop"
      :freight-allowance="freightAllowance"
      :loading="rateShopLoading"
      :selectable="selectable"
      :updatable="updatable"
      :view-uplift="viewUplift"
      :line-items-missing-dims="lineItemsMissingDims"
      :freight-allowance-editable="freightAllowanceEditable"
      editable
      @edit-quote="emit('edit-quote', $event)"
      @rate-selected="emit('rate-selected', $event)"
      @rate-shop-completed="emit('rate-shop-completed')"
      @send-to-brokerage="emit('send-to-brokerage', $event)"
      @update:freight-allowance="emit('update:freight-allowance', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { Loadable } from '@rygen/rygen-ui/model';

import {
  AcceptQuotePayload,
  FreightAllowance,
  RateQuote,
  RateShop,
  type ServiceTypeFilters,
} from '@/model';

import { OrderRateShopTab } from '@/components/order/rateShop/OrderRateShopTabs.vue';
import RateShopView from '@/components/rateShop/RateShop.vue';

const serviceTypeFilters = defineModel('serviceTypeFilters', {
  type: Object as PropType<ServiceTypeFilters>,
  default: () => ({}),
});

const props = defineProps({
  tab: {
    type: Object as PropType<OrderRateShopTab>,
    required: true,
  },
  shipmentSpecId: {
    type: Number,
    required: true,
  },
  rateShop: {
    type: Object as PropType<Loadable<RateShop>>,
    required: true,
  },
  /**
   * The Freight Allowance Amount for the entity (e.g. Shipment, ShipmentSpec) this rate shop represents
   */
  freightAllowance: {
    type: Object as PropType<FreightAllowance | undefined>,
    default: () => undefined,
  },
  rateShopLoading: {
    type: Boolean,
    default: () => false,
  },
  selectable: {
    type: Boolean,
    default: () => false,
  },
  updatable: {
    type: Boolean,
    default: () => false,
  },
  viewUplift: {
    type: Boolean,
    default: () => false,
  },
  lineItemsMissingDims: {
    type: Boolean,
    default: () => false,
  },
  freightAllowanceEditable: {
    type: Boolean,
    default: () => false,
  },
});
const {
  tab,
  shipmentSpecId,
  rateShop,
  freightAllowance,
  rateShopLoading,
  selectable,
  updatable,
  viewUplift,
  lineItemsMissingDims,
  freightAllowanceEditable,
} = toRefs(props);
const emit = defineEmits<{
  (event: 'edit-quote', rateQuote: RateQuote): void;
  (event: 'rate-selected', payload: AcceptQuotePayload): void;
  (event: 'rate-shop-completed'): void;
  (event: 'send-to-brokerage', payload: Partial<AcceptQuotePayload>): void;
  (
    event: 'update:freight-allowance',
    freightAllowance?: FreightAllowance,
  ): void;
}>();
</script>
